import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

const container = document.querySelector('#root');

function Loader() {
  const loading = useSelector((state) => state.loader.loading);

  if (!loading || loading < 0) return null;

  return createPortal(
    <div className="loader-container">
      <div className="loader-spinner" />
    </div>,
    container
  );
}

export default Loader;